import { SxProps } from '@mui/material';
import { CSSProperties } from 'react';

export const styles: { [key: string]: SxProps } = {
  container: {
    display: 'flex',
    flexDirection: {
      xs: 'column',
      md: 'row'
    },
    gap: 3,
    height: 'calc(100vh - 48px)',
    overflow: 'hidden'
  },
  contentSection: {
    flex: {
      xs: '1 1 auto',
      md: '0 0 400px'
    },
    overflow: 'auto',
    p: 2
  },
  mapSection: {
    flex: {
      xs: '0 0 400px',
      md: '1 1 auto'
    },
    display: 'flex',
    flexDirection: 'column',
    overflow: 'auto',
    p: 2
  },
  hiddenInput: {
    display: 'none'
  },
  mapContainer: {
    height: '600px',
    width: '100%',
    borderRadius: 1,
    overflow: 'hidden',
    position: 'relative'
  },
  locationInfo: {
    mb: 2
  },
  statsDisplay: {
    mb: 2,
    display: 'flex',
    gap: 2,
    flexWrap: 'wrap'
  },
  locationForm: {
    '& .MuiTextField-root, & .MuiFormControl-root': {
      mb: 2
    },
    '& .MuiInputBase-root': {
      minHeight: '40px'
    }
  },
  photoContainer: {
    mb: 2
  },
  photoPreview: {
    mt: 1
  },
  photo: {
    maxWidth: '100%',
    maxHeight: 200,
    objectFit: 'cover',
    borderRadius: 1
  },
  buttonGroup: {
    mt: 2,
    display: 'flex',
    gap: 2
  },
  formField: {
    '& .MuiInputBase-root': {
      height: '40px'
    },
    '& .MuiInputBase-multiline': {
      height: 'auto',
      minHeight: '40px'
    }
  }
};

export const cssStyles: { [key: string]: CSSProperties } = {
  hiddenInput: {
    display: 'none'
  },
  photo: {
    maxWidth: '100%',
    maxHeight: 200,
    objectFit: 'cover',
    borderRadius: '4px'
  }
}; 